<template>
  <div id="search-log">
    <v-container grid-list-xl>
      <v-layout align-center row wrap>
        <v-flex xs6>
          <div class="headline">Search Log</div>
        </v-flex>
        <v-flex xs2>
          <v-autocomplete
            :items="products"
            class="font-weight-medium"
            clearable
            item-text="productname"
            item-value="productname"
            label="ผลผลิต"
            v-model.trim="searchKey"
          ></v-autocomplete>
        </v-flex>
        <v-flex xs2>
          <v-menu
            :close-on-content-click="false"
            :nudge-right="40"
            full-width
            lazy
            min-width="290px"
            offset-y
            transition="scale-transition"
            v-model="menuDate"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                clearable
                label="วันที่"
                readonly
                v-model="searchDate"
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker @input="menuDate = false" v-model="searchDate"></v-date-picker>
          </v-menu>
        </v-flex>
        <v-flex xs2>
          <v-menu
            :close-on-content-click="false"
            :nudge-right="40"
            :return-value.sync="searchTime"
            full-width
            lazy
            max-width="290px"
            min-width="290px"
            offset-y
            ref="menu"
            transition="scale-transition"
            v-model="menuTime"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                clearable
                label="เวลา"
                readonly
                v-model="searchTime"
                v-on="on"
              ></v-text-field>
            </template>
            <v-time-picker
              @click:minute="$refs.menu.save(searchTime)"
              format="24hr"
              full-width
              v-if="menuTime"
              v-model="searchTime"
            ></v-time-picker>
          </v-menu>
        </v-flex>
        <v-flex xs12>
          <!-- Data Table -->
          <v-data-table
            :headers="headers"
            :items="filterStates"
            :loading="tableLoading"
            class="elevation-0"
            disable-initial-sort
            hide-actions
          >
            <template slot="items" slot-scope="props">
              <tr>
                <td>{{ props.item.keyword }}</td>
                <td>{{ props.item.ip || '-' }}</td>
                <td>{{ props.item.acceptDate.slice(0, 10) || '-' }}</td>
                <td>{{ props.item.acceptTime.slice(0, 5) || '-' }}</td>
              </tr>
            </template>
          </v-data-table>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import _ from 'lodash/orderBy'
export default {
  name: 'search-log',
  data() {
    return {
      states: [],
      searchKey: '',
      searchDate: '', //new Date().toISOString().substr(0, 10)
      menuDate: false,
      searchTime: '',
      menuTime: false,
      // Table
      tableLoading: false,
      headers: [
        { text: 'Keyword', align: 'left', value: 'keyword', width: '200' },
        { text: 'IP', align: 'left', value: 'ip', width: '100' },
        { text: 'Date', align: 'left', value: 'acceptDate', width: '100' },
        {
          text: 'Time',
          align: 'left',
          value: 'acceptTime',
          width: '100'
        }
      ]
    }
  },
  computed: {
    filterStates() {
      if (this.searchKey) {
        return this.states.filter(item => item.keyword == this.searchKey)
      }
      if (this.searchDate) {
        return this.states.filter(item => item.acceptDate.match(this.searchDate))
      }
      if (this.searchTime) {
        return this.states.filter(item => item.acceptTime.match(this.searchTime))
      } else {
        return this.states
      }
    },
    products() {
      return _(this.$store.state.Product.searchProducts, ['id', 'orders'], ['asc', 'asc'])
    }
  },
  async created() {
    this.tableLoading = !this.tableLoading
    await this.getSearchLog()
    this.tableLoading = !this.tableLoading
  },
  methods: {
    async getSearchLog() {
      try {
        const response = await this.axios.get(`farmerspace/search-log`)
        this.states = response.data
      } catch (error) {
        throw new Error(error)
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>
